// import React, { useState } from 'react'
// import { Mail } from "lucide-react";
// import { Link } from 'react-router-dom';
// import { CHANGELOG_DATA } from "./ChangeLogData";
// import { ChevronDown, ChevronUp } from "lucide-react";

// export default function PublicChangeLog() {
//     const [openVersion, setOpenVersion] = useState(CHANGELOG_DATA[0].version);
//     const toggle = (version) => {
//         setOpenVersion(openVersion === version ? null : version);
//     };
//     return (
//         <div>
//             <div className="bg-gradient-to-br from-[#093A5B] to-[#0A4D70] text-white py-20">
//                 <div className="max-w-[980px] mx-auto px-8 text-center">

//                     {/* TITLE */}
//                     <h1 className="text-white mb-4 text-4xl font-bold">
//                         What’s new in Simplifyte
//                     </h1>

//                     {/* SUBTITLE */}
//                     <p className="text-white/80 text-xl mb-8 max-w-2xl mx-auto">
//                         All the latest features, improvements, and fixes.
//                         Stay up to date with everything we ship.
//                     </p>

//                     {/* BUTTONS */}
//                     <div className="flex gap-4 justify-center">

//                         {/* SUBSCRIBE BUTTON */}
//                         <button className="px-5 py-2.5 rounded-xl transition-smooth font-medium
//                              bg-white text-[#093A5B] hover:bg-[#F8FAFC] active:scale-[0.98]
//                              flex items-center border-0">
//                             <Mail className="w-4 h-4 mr-2" />
//                             <span className="text-[#093A5B]">Subscribe to updates</span>
//                         </button>

//                         {/* VIEW DOCS BUTTON */}
//                         <a href="/frame/docs-home">
//                             <button className="px-5 py-2.5 rounded-xl transition-smooth font-medium
//                                bg-transparent text-white border border-white/20
//                                hover:bg-white/10">
//                                 View documentation
//                             </button>
//                         </a>
//                     </div>

//                 </div>
//             </div>
//             <div className="max-w-[900px] mx-auto px-6 py-16">
//                 <h1 className="text-4xl font-bold text-[#093A5B] mb-10">
//                     Product Changelog
//                 </h1>

//                 <div className="relative">
//                     {/* Vertical timeline line */}
//                     <div className="absolute left-4 top-0 w-[2px] h-full bg-[#E5E7EB]"></div>

//                     {CHANGELOG_DATA.map((log) => (
//                         <div key={log.version} className="mb-16 relative pl-10">
//                             {/* Dot on the line */}
//                             <div className="absolute left-[6px] top-1 w-3 h-3 bg-[#0EA5E9] rounded-full"></div>

//                             {/* Version Header */}
//                             <div
//                                 className="flex items-center justify-between cursor-pointer"
//                                 onClick={() => toggle(log.version)}
//                             >
//                                 <div>
//                                     <div className="text-sm text-[#6B7280]">
//                                         v{log.version} — {log.title}
//                                     </div>
//                                     <div className="text-sm text-[#6B7280]">
//                                         Released {log.releasedOn} • {log.updatesCount} updates
//                                     </div>
//                                 </div>

//                                 {openVersion === log.version ? (
//                                     <ChevronUp className="text-[#093A5B]" />
//                                 ) : (
//                                     <ChevronDown className="text-[#093A5B]" />
//                                 )}
//                             </div>

//                             {/* Collapsible Content */}
//                             {openVersion === log.version && (
//                                 <div className="mt-6 space-y-10 border-l border-[#E5E7EB] pl-6">
//                                     {log.sections.map((section, idx) => (
//                                         <div key={idx}>
//                                             <div className="flex items-center gap-2 text-lg font-semibold text-[#093A5B] mb-4">
//                                                 <span>{section.icon}</span> {section.sectionTitle}
//                                             </div>

//                                             <div className="space-y-8">
//                                                 {section.items.map((item, i) => (
//                                                     <div key={i} className="border-b pb-6">
//                                                         <h3 className="text-xl font-medium text-[#093A5B] mb-1">
//                                                             {item.title}
//                                                         </h3>

//                                                         <p className="text-[#6B7280] mb-3">
//                                                             {item.description}
//                                                         </p>

//                                                         <a
//                                                             href={item.learnMore}
//                                                             className="text-[#0EA5E9] font-medium hover:underline"
//                                                         >
//                                                             Learn more →
//                                                         </a>
//                                                     </div>
//                                                 ))}
//                                             </div>
//                                         </div>
//                                     ))}
//                                 </div>
//                             )}
//                         </div>
//                     ))}
//                 </div>
//             </div>

//         </div>
//     )
// }

// 16/01/26 close kariyu
// import React, { useEffect, useState } from 'react';
// import { Mail, ChevronDown, ChevronUp } from "lucide-react";
// import { motion, AnimatePresence } from "framer-motion";
// import { CHANGELOG_DATA } from "./ChangeLogData";
// import SubscribeToUpdates from './SubscribeToUpdates';
// import HeaderMenu from '../../Navbar/headermenu';
// import CustomFooter from '../../Footer/customFooter';
// import apiClient from '../../../config/apiClient';

// export default function PublicChangeLog() {
//   // const [openVersion, setOpenVersion] = useState(CHANGELOG_DATA.version); //[0]
//   const [openVersion,setOpenVersion] = useState(null)
//   const [showSubscribe, setShowSubscribe] = useState(false);
//   const [ChangeLogData,setChangeLogData] = useState([])
//   const [Loading,setLoading]= useState(false)
//   const [Error,setError]=useState(null)

//   const handleShow = async()=>{
//     setLoading(true)
//     try{
//       const res = await apiClient.get('/releases')
//       console.log('API Res',res.data.data)
//       setChangeLogData(res.data.data || [])
//     }catch(error){
//       setError("Failed to Fetch",error);
//       setChangeLogData([]);
//     }finally{
//       setLoading(false)
//     }
//   }
//   useEffect(()=>{
//     handleShow()
//   },[])
//   const toggle = (version) => {
//     setOpenVersion(openVersion === version ? null : version);
//   };
//   // const handleUpdate =()=>{
//   //   // console.log("Hello")
//   //   setIsopen(true);
//   // }

//   return (
//     <div>
//       <HeaderMenu/>
//       {/* HERO - Unchanged */}
//       <div className="bg-gradient-to-br from-[#093A5B] to-[#0A4D70] text-white py-20">
//         <div className="max-w-[980px] mx-auto px-8 text-center mt-20">
//           <h1 className="text-white mb-4 text-4xl font-bold">
//             What’s new in Simplifyte
//           </h1>
//           <p className="text-white/80 text-xl mb-8 max-w-2xl mx-auto">
//             All the latest features, improvements, and fixes.
//             Stay up to date with everything we ship.
//           </p>
//           <div className="flex gap-4 justify-center">
//             <button onClick={() => setShowSubscribe(true)}   // THIS LINE WAS MISSING!
//             className="px-5 py-2.5 rounded-xl transition-smooth font-medium
//                  bg-white text-[#093A5B] hover:bg-[#F8FAFC] active:scale-[0.98]
//                  flex items-center border-0"
//                  >
//               <Mail className="w-4 h-4 mr-2" />
//               <span className="text-[#093A5B]">Subscribe to updates</span>
//             </button>

//             {/* {isopen && (

//                 <SubscribeToUpdates />
//             )} */}
//          <SubscribeToUpdates
//         isOpen={showSubscribe}
//         onClose={() => setShowSubscribe(false)}
//       />
//             <a href="/frame/docs-home">
//               <button className="px-5 py-2.5 rounded-xl transition-smooth font-medium
//                    bg-transparent text-white border border-white/20
//                    hover:bg-white/10">
//                 View documentation
//               </button>
//             </a>
//           </div>
//         </div>
//       </div>

//       {/* CHANGELOG - Only animation improved */}
//       <div className="max-w-[900px] mx-auto px-6 py-16">
//         <h1 className="text-4xl font-bold text-[#093A5B] mb-10">
//           Product Changelog
//               {console.log('ChangeLogData',ChangeLogData)}
//               {console.log('ID Che ke nai',ChangeLogData.id)}

//         </h1>
//         {Loading ? (
//           <div>Loading...</div>
//         ):Error ? (
//           <div>Error:{Error}</div>
//         ):

//         <div className="relative">
//           {/* Vertical Line */}
//           <div className="absolute left-2 top-0 w-[2px] h-full bg-[#E5E7EB]" />

//           {ChangeLogData && Array.isArray(ChangeLogData) && ChangeLogData.map((log) => (
//           //  CHANGELOG_DATA
//            <div key={log.id} className="mb-6 relative pl-10 ">
//               {/* Perfect Timeline Dot */}
//               <div className="absolute left-[6px] -translate-x-1/2 top-4 w-4 h-4 bg-[#0EA5E9] rounded-full ring-4 ring-white shadow-md" />

//               {/* Version Header */}
//               <div
//                 className="flex items-center justify-between cursor-pointer select-none hover:bg-[#F8FAFC] rounded-lg"
//                 onClick={() => toggle(log.version)}
//               >
//                 <div className='flex flex-row gap-5 items-center justify-between w-full
//                  py-3 px-6 -mx-6 rounded-xl hover:bg-[#F8FAFC] transition-all duration-200'>
//                   <div className="text-sm text-[#6B7280] font-medium ">
//                     <span className='text-[#093A5B] font-semibold text-lg whitespace-nowrap'>
//                       {log.version}
//                       </span>{" "}
//                        <span className='text-[#6B7280] text-lg truncate'>
//                          {log.title}
//                          {/* {log.id} */}
//                         </span>
//                   </div>
//                   <div className='flex flex-row gap-4 '>

//                   <div className="text-sm text-[#6B7280] inline-flex flex-row gap-4 items-center">
//                     <div className='text-[#6B7280] text-sm whitespace-nowrap'><span> {log.updatesCount} </span>
//                     <span>updates</span>
//                     </div>
//                     <span className='text-[#093A5B] font-medium text-base whitespace-nowrap'>{log.releasedOn}</span>
//                   </div>

//                 {/* SUPER SMOOTH CHEVRON ANIMATION */}
//                 <motion.div
//                   animate={{ rotate: openVersion === log.version ? 180 : 0 }}
//                   transition={{ duration: 0.55, ease: "easeOut" }}
//                   className="flex items-center justify-center "
//                 >
//                   {openVersion === log.version ? (
//                     <ChevronUp className="w-5 h-5 text-[#093A5B]" />
//                   ) : (
//                     <ChevronDown className="w-5 h-5 text-[#093A5B]" />
//                   )}
//                 </motion.div>
//               </div>
//               </div>
//               </div>

//               {/* SMOOTH COLLAPSIBLE CONTENT */}
//               <AnimatePresence>
//                 {openVersion === log.version && log.updates && Array.isArray(log.updates) && (
//                   <motion.div
//                     initial={{ height: 0, opacity: 0 }}
//                     animate={{ height: "auto", opacity: 1 }}
//                     exit={{ height: 0, opacity: 0 }}
//                     transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
//                     className="overflow-hidden"
//                   >
//                     <div className="mt-6 space-y-10  border-[#E5E7EB] pl-6 ">
//                       {log.updates && Array.isArray(log.updates) && log.updates.length > 0 && log.updates?.map((updates, idx) => (
//                         <motion.div
//                           key={idx}
//                           initial={{ opacity: 0, x: -20 }}
//                           animate={{ opacity: 1, x: 0 }}
//                           transition={{ delay: idx * 0.1 }}
//                         >
//                           {console.log('Let Obj',log)}
//                           <div className="flex items-center gap-2 text-lg font-semibold text-[#093A5B] mb-4">
//                             {console.log("ChangeLog updates",ChangeLogData)}
//                             <span>{updates.icon}</span> {updates.sectionTitle}
//                             {console.log('updates che ke nai',updates.icon)}
//                           </div>

//                           <div className="space-y-8">
//                             {(updates.items || []).map((item, i) => (
//                               <motion.div
//                                 key={i}
//                                 initial={{ opacity: 0, y: 10 }}
//                                 animate={{ opacity: 1, y: 0 }}
//                                 transition={{ delay: i * 0.05 }}
//                                 className="border-b border-gray-200 pb-6 last:border-0"
//                               >
//                                 <h3 className="text-xl font-medium text-[#093A5B] mb-1">
//                                   {item.title}
//                                 </h3>
//                                 <p className="text-[#6B7280] mb-3 leading-relaxed">
//                                   {item.description}
//                                 </p>
//                                 <a
//                                   href={item.learnMore}
//                                   className="text-[#0EA5E9] font-medium hover:underline inline-flex items-center gap-1"
//                                 >
//                                   Learn more →
//                                 </a>
//                               </motion.div>
//                             ))}
//                           </div>
//                         </motion.div>
//                       ))}
//                     </div>
//                   </motion.div>
//                 )}
//               </AnimatePresence>
//             </div>
//           ))}
//         </div>
//         }
//       </div>
//       <CustomFooter/>
//     </div>
//   );
// }

import React, { useEffect, useState } from "react";
import { Mail, ChevronDown, ChevronUp } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import SubscribeToUpdates from "./SubscribeToUpdates";
import HeaderMenu from "../../Navbar/headermenu";
import CustomFooter from "../../Footer/customFooter";
import apiClient from "../../../config/apiClient";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
// import "D:\Simplifyte\Website-www.simplifyte.com\src\component\Docs\PublicChangeLog\ChangeLog.css"
import "../PublicChangeLog/ChangeLog.css";

export default function PublicChangeLog() {
  const [openVersion, setOpenVersion] = useState(null);
  const [showSubscribe, setShowSubscribe] = useState(false);
  const [ChangeLogData, setChangeLogData] = useState([]);
  const [Loading, setLoading] = useState(false);
  const [Error, setError] = useState(null);

  const navigate = useNavigate();
  const handleShow = async () => {
    setLoading(true);
    try {
      const res = await apiClient.get("/releases");
      // console.log("API Response:", res.data.data);

      // Filter only published releases
      const publishedReleases = res.data.data.filter(
        (release) => release.status === "Published",
      );
      // console.log("Published Releases:", publishedReleases);

      setChangeLogData(publishedReleases || []);
    } catch (error) {
      console.error("API Error:", error);
      setError("Failed to Fetch");
      setChangeLogData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleShow();
  }, []);
  const toggle = (version) => {
    setOpenVersion(openVersion === version ? null : version);
  };

  // ✅ Get icon based on update type
  const getIconByType = (type) => {
    switch (type?.toLowerCase()) {
      case "new":
        return "🎉";
      case "improved":
        return "⚡";
      case "fixed":
        return "🛠️";
      case "deprecated":
        return "⚠️";
      case "note":
        return "📝";
      default:
        return "📋";
    }
  };

  // ✅ Get section title based on type
  const getSectionTitleByType = (type) => {
    switch (type?.toLowerCase()) {
      case "new":
        return "New Features";
      case "improved":
        return "Improvements";
      case "fixed":
        return "Bug Fixes";
      case "note":
        return "Notes";
      default:
        return "Updates";
    }
  };

  // ✅ Group updates by type
  const groupUpdatesByType = (updates) => {
    if (!updates || !Array.isArray(updates) || updates.length === 0) {
      return [];
    }

    const grouped = {};

    updates.forEach((update) => {
      const type = update.type || "other";
      if (!grouped[type]) {
        grouped[type] = [];
      }
      grouped[type].push(update);
    });

    return Object.entries(grouped).map(([type, items]) => ({
      type,
      icon: getIconByType(type),
      sectionTitle: getSectionTitleByType(type),
      items: items || [],
    }));
  };

  return (
    <div>
      <Helmet>
        <title>What's new in Simplifyte | Change Log</title>
      </Helmet>
      <HeaderMenu />

      {/* HERO Section */}
      {/* bg-gradient-to-br from-[#093A5B] to-[#0A4D70] text-white py-20 */}
      <div className="Change_Log_Main_Class">
        {/* max-w-[980px] mx-auto px-8 text-center mt-20 */}
        <div className="Change_Log_Sab_Class">
          {/* text-white mb-4 text-[55px] font-bold  */}
          <h1 className="Change_Log_Main_Heading">What's new in Simplifyte</h1>
          {/* text-white/80 text-xl mb-8 max-w-2xl mx-auto text-[18px] */}
          <p className="Change_Log_Para">
            All the latest features, improvements, and fixes. Stay up to date
            with everything we ship.
          </p>
          {/* <div className="flex gap-4 justify-center">
            <button
              onClick={() => setShowSubscribe(true)}
              className="px-5 py-2.5 rounded-xl transition-smooth font-medium 
                bg-white text-[#093A5B] hover:bg-[#F8FAFC] active:scale-[0.98]
                flex items-center border-0"
            >
              <Mail className="w-4 h-4 mr-2" />
              <span className="text-[#093A5B]">Subscribe to updates</span>
            </button>

            <SubscribeToUpdates
              isOpen={showSubscribe}
              onClose={() => setShowSubscribe(false)}
            />
            
            <a href="">
              <button className="px-5 py-2.5 rounded-xl transition-smooth font-medium 
                bg-transparent text-white border border-white/20 
                hover:bg-white/10"
                onClick={()=>navigate("/docs")}>
                View documentation
              </button>
            </a>
          </div> */}
          <div className="changelog-button-group">
            <button
              onClick={() => setShowSubscribe(true)}
              className="subscribe-btn"
            >
              <Mail className="subscribe-icon" />
              <span className="subscribe-btn-text">Subscribe to updates</span>
            </button>

            <SubscribeToUpdates
              isOpen={showSubscribe}
              onClose={() => setShowSubscribe(false)}
            />

            <button className="docs-btn " onClick={() => navigate("/docs")}>
              View documentation
            </button>
          </div>
        </div>
      </div>

      {/* CHANGELOG Section */}
      {/* max-w-[900px] mx-auto px-6 py-16 */}
      <div className="Change_Log_Product_Class">
        {/* text-4xl font-bold text-[#093A5B] mb-10 */}
        <h1 className="Change_Log_Product_Heading">Product Changelog</h1>

        {Loading ? (
          <div className="text-center py-10">Loading...</div>
        ) : Error ? (
          <div className="text-center py-10 text-red-600">Error: {Error}</div>
        ) : !ChangeLogData ||
          !Array.isArray(ChangeLogData) ||
          ChangeLogData.length === 0 ? (
          <div className="text-center py-10 text-gray-600">
            No changelog data available
          </div>
        ) : (
          <div className="relative">
            {/* absolute left-2 top-0 w-[2px] h-full bg-[#E5E7EB] */}
            <div className="Change_Log_Product_Line" />

            {ChangeLogData.map((log) => {
              const logId = log?.id || Math.random().toString();
              const version = log?.version || "Unknown Version";
              const title = log?.title || "No Title";
              const updatesCount = log?.updates?.length || 0;
              const date =
                log?.date || log?.created_at?.split("T")[0] || "Unknown Date";
              const updates = log?.updates || [];

              // Group updates by type
              const groupedUpdates = groupUpdatesByType(updates);

              return (
                // mb-6 relative pl-10
                <div key={logId} className="Change_Log_Product_Data">
                  {/* Timeline Dot */}
                  {/* absolute left-[6px] -translate-x-1/2 top-4 w-4 h-4 bg-[#0EA5E9] rounded-full ring-4 ring-white shadow-md */}
                  <div className="Change_Log_Timeline_Dot" />

                  {/* Version Header */}
                  <div
                    className="flex items-center justify-between cursor-pointer select-none"
                    onClick={() => toggle(version)}
                  >
                    {/* flex flex-row gap-5 items-center justify-between w-full py-3 px-6 -mx-6 rounded-xl hover:bg-[#F8FAFC] transition-all
                       duration-200  */}
                    <div
                      className={`Change_Log_ProductActive_Class ${openVersion === version ? "!bg-[#093A5B]" : ""}`}
                    >
                      {/* <div className="text-sm text-[#6B7280] font-medium">
                        <span className={`font-semibold text-lg whitespace-nowrap ${openVersion === version ? "text-[#fff]" :"text-[#093A5B]"}` }>
                          {version}
                        </span> {" "}
                        <span className={`ml-2 text-lg truncate ${openVersion === version ? "text-[#fff]" :"text-[#6B7280]"}`}>
                          {title}
                        </span>
                      </div> */}
                      <div className="Change_Log_Product_Title">
                        <span
                          className={`Change_Log_Product_Version ${
                            openVersion === version ? "active" : ""
                          }`}
                        >
                          {version}
                        </span>

                        <span
                          className={`Change_Log_Product_Name ${
                            openVersion === version ? "active" : ""
                          }`}
                        >
                          {title}
                        </span>
                      </div>

                      {/* <div className="flex flex-row gap-4">
                        <div className="text-sm text-[#6B7280] inline-flex flex-row gap-4 items-center">
                          <div
                            className={`text-[#6B7280] text-sm whitespace-nowrap ${openVersion === version ? "text-[#fff]" : "text-[#6B7280]"}`}
                          >
                            <span>{updatesCount} </span>
                            <span>updates</span>
                          </div>
                          <span
                            className={`font-medium text-base whitespace-nowrap ${openVersion === version ? "text-[#fff]" : "text-[#6B7280]"}`}
                          >
                            {date}
                          </span>
                        </div>

                        <motion.div
                          animate={{ rotate: openVersion === version ? 0 : 0 }}
                          transition={{ duration: 0.55, ease: "easeOut" }}
                          className="flex items-center justify-center"
                        >
                          {openVersion === version ? (
                            <ChevronUp
                              className={`w-5 h-5 ${openVersion === version ? "text-[#fff]" : "text-[#6B7280]"}`}
                            />
                          ) : (
                            <ChevronDown className="w-5 h-5 text-[#093A5B]" />
                          )}
                        </motion.div>
                      </div> */}
                      <div className="Change_Log_Product_Info">
                        <div className="Change_Log_Product_Meta">
                          <div
                            className={`Change_Log_Product_Updates ${
                              openVersion === version ? "active" : ""
                            }`}
                          >
                            <span>{updatesCount}</span>
                            <span> updates</span>
                          </div>

                          <span
                            className={`Change_Log_Product_Date ${
                              openVersion === version ? "active" : ""
                            }`}
                          >
                            {date}
                          </span>
                        </div>

                        <motion.div
                          animate={{ rotate: openVersion === version ? 0 : 0 }}
                          transition={{ duration: 0.55, ease: "easeOut" }}
                          className="Change_Log_Product_Icon"
                        >
                          {openVersion === version ? (
                            <ChevronUp className="Change_Log_Icon active" />
                          ) : (
                            <ChevronDown className="Change_Log_Icon" />
                          )}
                        </motion.div>
                      </div>
                    </div>
                  </div>

                  {/* Collapsible Content */}
                  {/* <AnimatePresence>
                    {openVersion === version && groupedUpdates.length > 0 && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
                        className="overflow-hidden"
                      >
                        <div className="mt-6 space-y-10 border-[#E5E7EB] pl-6">
                          {groupedUpdates.map((section, idx) => (
                            <motion.div
                              key={idx}
                              initial={{ opacity: 0, x: -20 }}
                              animate={{ opacity: 1, x: 0 }}
                              transition={{ delay: idx * 0.1 }}
                            >
                              <div className="flex items-center gap-2 text-lg font-semibold text-[#093A5B] mb-4">
                                <span>{section.icon}</span>{" "}
                                {section.sectionTitle}
                              </div>

                              <div className="space-y-8">
                                {section.items.map((item, i) => (
                                  <motion.div
                                    key={i}
                                    initial={{ opacity: 0, y: 10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ delay: i * 0.05 }}
                                    className="border-b border-gray-200 pb-6 last:border-0"
                                  >
                                    <h3 className="text-xl font-medium text-[#093A5B] mb-1">
                                      {item.title || "Update"}
                                    </h3>
                                    <p className="text-[#6B7280] mb-3 leading-relaxed">
                                      {item.description ||
                                        "No description available"}
                                    </p>
                                  </motion.div>
                                ))}
                              </div>
                            </motion.div>
                          ))}
                        </div>
                      </motion.div>
                    )}
                  </AnimatePresence> */}
                  <AnimatePresence>
                    {openVersion === version && groupedUpdates.length > 0 && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
                        className="Change_Log_Update_Container"
                      >
                        <div className="Change_Log_Update_Wrapper">
                          {groupedUpdates.map((section, idx) => (
                            <motion.div
                              key={idx}
                              initial={{ opacity: 0, x: -20 }}
                              animate={{ opacity: 1, x: 0 }}
                              transition={{ delay: idx * 0.1 }}
                              className="Change_Log_Update_Section"
                            >
                              <div className="Change_Log_Update_SectionTitle">
                                <span>{section.icon}</span>
                                {section.sectionTitle}
                              </div>

                              <div className="Change_Log_Update_List">
                                {section.items.map((item, i) => (
                                  <motion.div
                                    key={i}
                                    initial={{ opacity: 0, y: 10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ delay: i * 0.05 }}
                                    className="Change_Log_Update_Item"
                                  >
                                    <h3 className="Change_Log_Update_ItemTitle">
                                      {item.title || "Update"}
                                    </h3>

                                    <p className="Change_Log_Update_ItemDesc">
                                      {item.description ||
                                        "No description available"}
                                    </p>
                                  </motion.div>
                                ))}
                              </div>
                            </motion.div>
                          ))}
                        </div>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              );
            })}
          </div>
        )}
      </div>

      <CustomFooter />
    </div>
  );
}

// {}

// Grok
// Deepseek
// import React, { useState } from 'react'
// import { Mail, ChevronDown, ChevronUp, ExternalLink, Sparkles, Calendar, Zap, Users, Shield } from "lucide-react"
// import { Link } from 'react-router-dom'
// import { CHANGELOG_DATA } from "./ChangeLogData"

// export default function PublicChangeLog() {
//     const [openVersion, setOpenVersion] = useState(CHANGELOG_DATA[0].version)
//     const [isHovered, setIsHovered] = useState(null)

//     const toggle = (version) => {
//         setOpenVersion(openVersion === version ? null : version)
//     }

//     // Icon mapping for different section types
//     const sectionIcons = {
//         'New Features': <Sparkles className="w-5 h-5" />,
//         'Improvements': <Zap className="w-5 h-5" />,
//         'Bug Fixes': <Shield className="w-5 h-5" />,
//         'Performance': <Zap className="w-5 h-5" />
//     }

//     return (
//         <div className="min-h-screen bg-gradient-to-b from-white to-[#F8FAFC]">
//             {/* Hero Section */}
//             <div className="relative bg-gradient-to-br from-[#093A5B] via-[#0A4D70] to-[#0B5F8A] text-white overflow-hidden">
//                 {/* Background pattern */}
//                 <div className="absolute inset-0 opacity-10">
//                     <div className="absolute inset-0" style={{
//                         backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
//                     }}></div>
//                 </div>

//                 <div className="relative max-w-[980px] mx-auto px-6 py-24 text-center">
//                     <div className="inline-flex items-center gap-2 mb-4 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full text-sm font-medium">
//                         <span className="w-2 h-2 bg-emerald-400 rounded-full animate-pulse"></span>
//                         Live Updates • Latest: v{CHANGELOG_DATA[0].version}
//                     </div>

//                     <h1 className="text-white mb-6 text-5xl md:text-6xl font-bold tracking-tight">
//                         What's New in{' '}
//                         <span className="bg-gradient-to-r from-emerald-300 to-cyan-300 bg-clip-text text-transparent">
//                             Simplifyte
//                         </span>
//                     </h1>

//                     <p className="text-white/90 text-xl mb-10 max-w-2xl mx-auto leading-relaxed">
//                         Discover the latest features, improvements, and fixes.
//                         We're constantly evolving to make your experience better.
//                     </p>

//                     <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
//                         <button
//                             className="group px-6 py-3 rounded-xl transition-all duration-300 font-medium
//                 bg-white text-[#093A5B] hover:bg-[#F0F9FF] hover:shadow-lg hover:shadow-blue-500/20
//                 active:scale-[0.98] flex items-center border-0 shadow-md"
//                         >
//                             <Mail className="w-4 h-4 mr-3 group-hover:scale-110 transition-transform" />
//                             <span className="font-semibold">Subscribe to Updates</span>
//                         </button>

//                         <Link
//                             to="/frame/docs-home"
//                             className="group px-6 py-3 rounded-xl transition-all duration-300 font-medium
//                 bg-transparent text-white border border-white/30 hover:bg-white/10
//                 hover:border-white/50 backdrop-blur-sm flex items-center"
//                         >
//                             <span>View Documentation</span>
//                             <ExternalLink className="w-4 h-4 ml-3 group-hover:translate-x-1 transition-transform" />
//                         </Link>
//                     </div>
//                 </div>
//             </div>

//             {/* Changelog Content */}
//             <div className="max-w-[900px] mx-auto px-4 sm:px-6 py-16 md:py-20">
//                 <div className="mb-12">
//                     <h1 className="text-4xl md:text-5xl font-bold text-[#093A5B] mb-4">
//                         Product Changelog
//                     </h1>
//                     <p className="text-[#6B7280] text-lg">
//                         Track every improvement and enhancement we release
//                     </p>
//                 </div>

//                 <div className="relative">
//                     {/* Animated timeline line */}
//                     <div className="absolute left-4 sm:left-6 top-0 w-[2px] h-full bg-gradient-to-b from-[#0EA5E9]/20 via-[#0EA5E9] to-transparent"></div>

//                     {CHANGELOG_DATA.map((log) => (
//                         <div
//                             key={log.version}
//                             className={`mb-12 relative pl-10 sm:pl-12 transition-all duration-500 ${openVersion === log.version ? 'scale-[1.02] origin-left' : ''
//                                 }`}
//                             onMouseEnter={() => setIsHovered(log.version)}
//                             onMouseLeave={() => setIsHovered(null)}
//                         >
//                             {/* Enhanced timeline dot with animation */}
//                             <div className={`absolute left-3 sm:left-[22px] top-2 w-4 h-4 rounded-full
//                 ${openVersion === log.version ? 'scale-125' : ''} transition-all duration-300
//                 ${isHovered === log.version ? 'animate-pulse' : ''}
//                 ${log.version === CHANGELOG_DATA[0].version
//                                     ? 'bg-emerald-400 ring-4 ring-emerald-400/20'
//                                     : 'bg-[#0EA5E9] ring-2 ring-[#0EA5E9]/30'}`}
//                             ></div>

//                             {/* Version Card */}
//                             <div
//                                 className={`bg-white rounded-2xl p-6 sm:p-8 cursor-pointer transition-all duration-300
//                   ${openVersion === log.version
//                                         ? 'shadow-xl border-l-4 border-[#0EA5E9]'
//                                         : 'shadow-md hover:shadow-lg border-l-2 border-transparent hover:border-[#0EA5E9]/50'}
//                   ${isHovered === log.version ? 'translate-x-2' : ''}`}
//                                 onClick={() => toggle(log.version)}
//                             >
//                                 <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
//                                     <div className="flex-1">
//                                         <div className="flex items-center gap-3 mb-2">
//                                             <span className="text-xl font-bold text-[#093A5B]">
//                                                 v{log.version}
//                                             </span>
//                                             {log.version === CHANGELOG_DATA[0].version && (
//                                                 <span className="px-3 py-1 bg-emerald-400/10 text-emerald-600 text-xs font-semibold rounded-full">
//                                                     LATEST
//                                                 </span>
//                                             )}
//                                         </div>

//                                         <h3 className="text-lg font-semibold text-[#093A5B] mb-2">
//                                             {log.title}
//                                         </h3>

//                                         <div className="flex items-center gap-4 text-sm text-[#6B7280]">
//                                             <span className="flex items-center gap-1">
//                                                 <Calendar className="w-4 h-4" />
//                                                 {log.releasedOn}
//                                             </span>
//                                             <span className="flex items-center gap-1">
//                                                 <Users className="w-4 h-4" />
//                                                 {log.updatesCount} updates
//                                             </span>
//                                         </div>
//                                     </div>

//                                     <div className="flex items-center gap-2">
//                                         <span className="text-sm text-[#0EA5E9] font-medium">
//                                             {openVersion === log.version ? 'Collapse' : 'Expand'}
//                                         </span>
//                                         <div className={`p-2 rounded-lg transition-all duration-300
//                       ${openVersion === log.version ? 'bg-[#0EA5E9]/10' : 'bg-gray-100'}`}
//                                         >
//                                             {openVersion === log.version ? (
//                                                 <ChevronUp className="w-5 h-5 text-[#0EA5E9]" />
//                                             ) : (
//                                                 <ChevronDown className="w-5 h-5 text-[#6B7280]" />
//                                             )}
//                                         </div>
//                                     </div>
//                                 </div>

//                                 {/* Collapsible Content with smooth animation */}
//                                 {openVersion === log.version && (
//                                     <div className="mt-8 pt-8 border-t border-gray-100 animate-fadeIn">
//                                         <div className="space-y-10">
//                                             {log.sections.map((section, idx) => (
//                                                 <div key={idx} className="animate-slideUp" style={{ animationDelay: `${idx * 100}ms` }}>
//                                                     <div className="flex items-center gap-3 text-lg font-semibold text-[#093A5B] mb-6">
//                                                         <div className="p-2 rounded-lg bg-gradient-to-br from-blue-50 to-cyan-50">
//                                                             {sectionIcons[section.sectionTitle] || section.icon}
//                                                         </div>
//                                                         <span>{section.sectionTitle}</span>
//                                                     </div>

//                                                     <div className="space-y-6">
//                                                         {section.items.map((item, i) => (
//                                                             <div
//                                                                 key={i}
//                                                                 className="group p-5 rounded-xl hover:bg-gradient-to-r hover:from-white hover:to-blue-50/50
//                                   transition-all duration-300 border border-transparent hover:border-blue-100"
//                                                             >
//                                                                 <div className="flex items-start gap-4">
//                                                                     <div className="mt-1 p-1.5 rounded-md bg-blue-100/50 group-hover:bg-blue-100
//                                     transition-colors duration-300">
//                                                                         <div className="w-2 h-2 rounded-full bg-[#0EA5E9]"></div>
//                                                                     </div>

//                                                                     <div className="flex-1">
//                                                                         <h3 className="text-xl font-semibold text-[#093A5B] mb-2 group-hover:text-[#0A4D70]
//                                       transition-colors duration-300">
//                                                                             {item.title}
//                                                                         </h3>

//                                                                         <p className="text-[#6B7280] mb-4 leading-relaxed">
//                                                                             {item.description}
//                                                                         </p>

//                                                                         <a
//                                                                             href={item.learnMore}
//                                                                             className="inline-flex items-center gap-2 text-[#0EA5E9] font-semibold
//                                         hover:text-[#093A5B] transition-colors duration-300 group/learnmore"
//                                                                         >
//                                                                             <span>Learn more about this update</span>
//                                                                             <ExternalLink className="w-4 h-4 group-hover/learnmore:translate-x-1
//                                         transition-transform duration-300" />
//                                                                         </a>
//                                                                     </div>
//                                                                 </div>
//                                                             </div>
//                                                         ))}
//                                                     </div>
//                                                 </div>
//                                             ))}
//                                         </div>
//                                     </div>
//                                 )}
//                             </div>
//                         </div>
//                     ))}
//                 </div>

//                 {/* Footer note */}
//                 <div className="mt-20 text-center">
//                     <div className="inline-flex items-center gap-2 px-6 py-3 bg-white rounded-xl shadow-sm border border-gray-200">
//                         <span className="text-sm text-[#6B7280]">
//                             Want to suggest a feature or report a bug?{' '}
//                             <a href="/contact" className="text-[#0EA5E9] font-semibold hover:underline">
//                                 Contact our team
//                             </a>
//                         </span>
//                     </div>
//                 </div>
//             </div>

//             {/* Add custom animations to global CSS or tailwind config */}
//             <style jsx>{`
//         @keyframes fadeIn {
//           from { opacity: 0; }
//           to { opacity: 1; }
//         }

//         @keyframes slideUp {
//           from {
//             opacity: 0;
//             transform: translateY(10px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }

//         .animate-fadeIn {
//           animation: fadeIn 0.3s ease-out;
//         }

//         .animate-slideUp {
//           animation: slideUp 0.4s ease-out forwards;
//           opacity: 0;
//         }
//       `}</style>
//         </div>
//     )
// }
